import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { PlayerBonusDataResponse } from '@modules/players-bonuses/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  PLAYERS_BONUSES_LIST_API_URL,
  PLAYERS_BONUSES_LIST_QUERY_KEY,
  PLAYERS_BONUSES_PERMISSIONS,
} from '@modules/players-bonuses/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function usePlayersBonusesListQuery(tableState: Ref<ITableState>): IContextQueryResult<
  ITableDataResponse<PlayerBonusDataResponse>,
  Error
> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<PlayerBonusDataResponse>>({
    queryKey: [PLAYERS_BONUSES_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<PlayerBonusDataResponse>>(
      PLAYERS_BONUSES_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: PLAYERS_BONUSES_PERMISSIONS.PLAYERS_BONUSES_SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
